import React, { useEffect, useState } from "react";
import DisplayCard from "../../../../components/DisplayCard";
import userIcon from "../../../../assets/user.svg";
import { Link } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { GET_TOTAL } from "./Querries";
import { LoadingSpinner } from "./pages/SchoolList";
function SchoolOnboard() {
  const { data: schoolData, loading, error } = useQuery(GET_TOTAL);

  const [total, settotal] = useState<any>(null);
  useEffect(() => {
    if (schoolData?.getallschool?.pagination) {
      settotal(schoolData.getallschool.pagination.total);
    }
  }, [schoolData]);
  if (error) {
    return (
      <div className="text-center py-8 text-red-500">
        Error loading school details
      </div>
    );
  }
  return (
    <div className="flex flex-col space-y-4">
      {loading ? (
        <LoadingSpinner />
      ) : (
        <>
          <div className="w-full">
            <Link
              to="/create_school"
              className="px-4 py-2 bg-[#6F6AF8] rounded-md text-white float-right"
            >
              create new school
            </Link>
          </div>
          <div className="flex mt-5 max-w-5xl w-full flex-col space-y-2">
            <div className="flex items-center gap-x-6">
              <DisplayCard
                width="max-w-md w-full"
                icon={userIcon}
                to="/no-of-generated-credentials"
                label="No. of Generated Credentials"
                value={total}
              />
              <DisplayCard
                width="max-w-md w-full"
                icon={userIcon}
                to="/no-of-credentials-not-sent"
                label="No. of credentials not sent"
                value={total}
              />
              <DisplayCard
                width="max-w-md w-full"
                icon={""}
                to="/mou-doucment-unsigned"
                label="MOU Document Unsigned"
                value={total}
              />
            </div>
            <div className="flex items-center gap-x-6">
              <DisplayCard
                width="max-w-lg w-full"
                icon={""}
                to="/security-deposit-collected/"
                label="Security Deposit Collected"
                value={total}
              />
              <DisplayCard
                width="max-w-lg w-full"
                icon={""}
                to="/school-database-not-updated/"
                label="School Database not Updated"
                value={total}
              />
            </div>
            <div className="flex mt-5 items-center gap-x-6">
              <DisplayCard
                width="max-w-xl w-full"
                icon={""}
                to="/final-demo-left/"
                label="Final Demo left"
                value={total}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default SchoolOnboard;
